import Joi from 'joi-browser';

/**
 * 既往症更新用パラメータを作成
 * @param {object} param 更新データ
 * @return {object} 更新用パラメータ
 * */
const createUpdateAnamnesesParam = param => {
  return { worker_anamneses: param };
};

/**
 * 作業員一覧 労務安全基本情報 タブ での安全書類項目(要入力)バリデーション
 * @return {object} バリデーション用のスキーマ
 * このプロパティ設定の並び順に従って validate が行われる
 * */
const createValidateSchemaSafetyDocItem = () => {
  const validateSchema = Object.create(null);

  // 既往症有無
  validateSchema.anamnesis_type = Joi.number().required();

  // BLDE_V2-32618 安全書類項目ラベルはそのままに、既往症有無のみをチェックするようにする

  return validateSchema;
};

/**
 *
 * */
const AnamnesesService = {
  createUpdateAnamnesesParam,
  createValidateSchemaSafetyDocItem,
};

export default AnamnesesService;



// WEBPACK FOOTER //
// ./src/services/workers/anamneses/AnamnesesService.js